import { createAction } from '@reduxjs/toolkit';

export const showModal = createAction<boolean, 'items/SHOW_MODAL'>(
    'items/SHOW_MODAL'
);

export type TModalActions = ReturnType<typeof showModal>;
